export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"M18 6H8.83l6 6-6 6H18v2H6v-2l6-6-6-6V4h12z\"/>"
};